// extracted by mini-css-extract-plugin
export default {"loadingDialog":"LayerManager-module__loadingDialog__Qt5Ej","activeDialog":"LayerManager-module__activeDialog__Zksda"};